import axios from 'axios';

const instance = axios.create();

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Check if the request was for a protected route
      const protectedRoutes = ['/api/quizzes/complete', '/api/user/profile'];
      if (protectedRoutes.some(route => error.config.url.includes(route))) {
        localStorage.removeItem('token'); // Clear the invalid token
        window.location = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
